import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { PaymentMethodDetailsComponent } from './payment-method-details.component';

@NgModule({
  imports: [UiModule, CommonModule],
  declarations: [PaymentMethodDetailsComponent],
  exports: [PaymentMethodDetailsComponent],
})
export class PaymentMethodDetailsModule {}
